import Axios from 'axios'
import router from '@/router'
const pathAuth = () => `${window.$ApiHost}/login/`

const state = {
  user: {},
}
const mutations = {
  SET_USER_AUTH (state, { token, username, isLogin }) {
    state.user = { username, token, isLogin }
    localStorage.setItem('user', JSON.stringify(state.user))
    Axios.defaults.headers.common.Authorization = `Token ${token}`
  },
  CLEAR_USER_DATA (state) {
    state.user = {}
    localStorage.removeItem('user')
    Axios.defaults.headers.common.Authorization = ''
    if (router.history.current.name !== 'login') {
      router.push({ name: 'login' })
    }
  },
}
const actions = {
  async authorization ({ commit }, { username, password }) {
    try {
      const res = await Axios.post(pathAuth(), {
        username,
        password,
      })
      await commit('SET_USER_AUTH', {
        ...res.data,
        username,
        isLogin: true,
      })
      return res
    } catch (e) {
      return e.response
    }
  },
}
const getters = {
  me: state => state.user,
}

export default {
  state,
  mutations,
  actions,
  getters,
}
